import type {ParserT} from '@freckle/parser'
import {Parser, record, oneOf, string, literal, firstOf} from '@freckle/parser'
import {fancyApiFetch} from '@freckle/educator-entities/ts/common/helpers/ajax'
import type {SyncCsvIdpDataArtifact} from './roster-sync/artifact'
import {parse as parseSyncCsvIdpDataArtifact} from './roster-sync/artifact'

const _allArtifactTags = ['sync_csv_idp_data'] as const

export const allArtifactTags = [..._allArtifactTags]

type ArtifactTag = (typeof _allArtifactTags)[number]

const artifactTagParser = oneOf('ArtifactTagParser', allArtifactTags) as ParserT<ArtifactTag>

export type Artifact = {
  tag: ArtifactTag
  url: string
}

export const artifactParser: ParserT<Artifact> = record({
  tag: artifactTagParser,
  url: string()
})

export async function fetchArtifactData(artifact: Artifact): Promise<ArtifactData> {
  const res = await fancyApiFetch(artifact.url, {excludeEcho: true}).then(res => res.json())
  return Parser.run(res, artifactDataParser)
}

export type ArtifactData = {
  artifactTag: 'sync_csv_idp_data'
  data: SyncCsvIdpDataArtifact
}

export /* for testing */ const artifactDataParser: ParserT<ArtifactData> = firstOf(
  record({
    artifactTag: literal('sync_csv_idp_data'),
    data: parseSyncCsvIdpDataArtifact
  })
)
